import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { motion } from "framer-motion";

import { CalendlyInlineWidget } from "~/components/site/calendly";
import { item, Layout } from "~/components/site/layout";
import { ROUTE_DATA } from "~/lib/constants";
import { getMeta } from "~/lib/get-meta";
import { getUrls } from "~/lib/get-urls";

const { desc, path, title } = ROUTE_DATA.contact;

export function loader({ request }: LoaderFunctionArgs) {
  return {
    urls: getUrls({ path, request }),
  };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return data ? getMeta({ desc, title, urls: data.urls }) : [];
};

export default function Contact(): JSX.Element {
  return (
    <Layout>
      <section className="section-first">
        <div className="container">
          <div className="lg:grid lg:grid-cols-2 items-center gap-x-16">
            <motion.div variants={item}>
              <h1 className="eyebrow">Talk to sales</h1>
              <h2 className="mt-0 mb-6">
                Create and grow your own stablecoin program
              </h2>
              <p className="subheading mt-2 mb-12">
                Schedule a call with our team to learn how we can help, or reach
                out to us at{" "}
                <a className="link" href="mailto:support@brale.xyz">
                  support@brale.xyz
                </a>
                .
              </p>
            </motion.div>
            <motion.div variants={item}>
              <CalendlyInlineWidget url="https://calendly.com/d/ck6b-wqj-bzf/meet-with-brale?hide_landing_page_details=1&hide_gdpr_banner=1" />
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
